<simpel-note-liste
    [formArray]="formArray"
    [omraader]="omraader"
    [henvendelsestyper]="henvendelsestyper"
    [opgavestyringStatusser]="opgavestyringStatusser"
    [brugere]="brugere"
    [defaultOmraadeId]="defaultOmraadeId"
    [ingenNoterTekst]="ingenNoterTekst"
>
</simpel-note-liste>
